import { CtaButton } from "./CtaButton";
import { resolveCta } from "./ctaDefaults";
import type { CtaModuleProps } from "./renderProps";

export function CtaModule({ label, url }: CtaModuleProps) {
  const cta = resolveCta(label, url);

  return (
    <section className="cms-cta" data-cms-module="cta">
      <div className="cms-wrap">
        <CtaButton label={cta.label} url={cta.url} />
      </div>
    </section>
  );
}
